/**
 * Created with Mei Zhiwei on 2017-10-07 20:16:53.
 * Description: axios 全局过滤器
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: meizhiwei@meituan.com
 * @Last Modified time: 2018-09-13 16:13:36
 */
import axios from 'axios';
import auth from './auth';
import { Message } from 'iview';

axios.defaults.timeout = 15000;
axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  config => {
    config.headers.Accept = 'application/json';
    config.headers['X-Requested-with'] = 'XMLHttpRequest';
    // config.headers['swimlane'] = 'fanzhijie-usspi';
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  data => {
    if (data.data.status === 401) {
      auth.login();
    }
    return data;
  },
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        auth.login();
      } else if (error.response.status === 412) {
        auth.bind();
      } else if (error.response.status === 403) {
        Message.warning('您没有该页面的访问权限, 请联系管理员申请权限');
      } else {
        Message.error(error.response.data.message);
      }
    } else {
      Message.error('未知错误');
    }

    return Promise.reject(error);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/lib/axios.js